export default ({ NoContent }) => ({
  rootContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  noContentImage: {
    width: 175,
    height: 120,
    backgroundImage: ({ imagePath }) => `url("${imagePath}")`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
  },
  noContentText: {
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "normal",
    fontStyle: "normal",
    fontStretch: "condensed",
    lineHeight: "normal",
    letterSpacing: 0.09,
    color: NoContent.messageColor,
    marginTop: 20,
  },
  buttonContainer: {
    marginTop: 20,
  },
});
